import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "space-y-4" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Upon purchase you will receive your custom Dripversity NFT into your Ethereum Wallet. It will then be available in all Ethereum supported marketplaces like Opensea or Foundation. ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "italic" }, "New to Ethereum wallets? ", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Learn More ")
const _hoisted_6 = { class: "block" }

import AppButton from "@/components/app/AppButton.vue";
import LoadingIcon from "@/components/icons/LoadingIcon.vue";
import { storeToRefs } from "pinia";
import { useUserStore } from "@/store/modules/user";
import { routes } from "@/constants/";

export default /*#__PURE__*/_defineComponent({
  __name: 'MintStepConnectWallet',
  emits: ["submit"],
  setup(__props, { emit }) {

const { isConnected, connectingWallet, settingChain } = storeToRefs(
    useUserStore()
);



const onClick = async function () {
    emit("submit");
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, [
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _createVNode(_component_router_link, {
        class: "link-2",
        to: _unref(routes).support['How to create a wallet']
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createVNode(AppButton, {
      "full-width": "",
      size: "sm",
      onClick: _withModifiers(onClick, ["prevent"]),
      disabled: _unref(connectingWallet)
    }, {
      default: _withCtx(() => [
        (_unref(connectingWallet))
          ? (_openBlock(), _createBlock(LoadingIcon, { key: 0 }))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(connectingWallet) || _unref(settingChain)
                        ? "Connecting..."
                        : _unref(isConnected)
                        ? "Disconnect"
                        : "Connect Wallet"), 1)
      ]),
      _: 1
    }, 8, ["onClick", "disabled"])
  ]))
}
}

})